import { disableScroll, enableScroll, enableFocusTrap, disableFocusTrap } from './helpers';

const { breakpoints } = window.embark;

let detailsOpen = false;

const mapEls = [...document.querySelectorAll('.eml-map')];
if (mapEls.length) {
	// Function to check if any of the mapEls have details open.
	const areDetailsOpen = () => mapEls.some((map) => map.classList.contains('has-details'));

	mapEls.forEach((map) => {
		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					const { target } = mutation;
					if (target.classList.contains('has-details') && breakpoints.below('767')) {
						const focusTrapEl = target.querySelector('.eml-map__location-details-container');
						if (focusTrapEl) {
							enableFocusTrap(focusTrapEl);
						}

						disableScroll();

						if (window.embark.components.stickyHeader) {
							setTimeout(() => {
								window.embark.components.stickyHeader.hide();
							}, 50);
						}
					} else {
						enableScroll();
						disableFocusTrap();

						if (window.embark.components.stickyHeader) {
							window.embark.components.stickyHeader.show();
						}
					}
				}
			}
		});

		observer.observe(map, { attributes: true });
	});

	window.addEventListener('resize', () => {
		window.requestAnimationFrame(() => {
			if (breakpoints.above('767') && areDetailsOpen()) {
				enableScroll();
				disableFocusTrap();

				if (window.embark.components.stickyHeader) {
					window.embark.components.stickyHeader.show();
				}
			} else if (breakpoints.below('767') && areDetailsOpen()) {
				disableScroll();

				// Get the open details element and enable focus trap.
				const openDetails = mapEls.find((map) => map.classList.contains('has-details'));
				if (openDetails) {
					const focusTrapEl = openDetails.querySelector('.eml-map__location-details-container');
					if (focusTrapEl) {
						enableFocusTrap(focusTrapEl);
					}
				}

				if (window.embark.components.stickyHeader) {
					setTimeout(() => {
						window.embark.components.stickyHeader.hide();
					}, 50);
				}
			}
		});
	});
}
